import { useLocation } from "react-router-dom";
import { QueryParams } from "../interfaces/DropdownItem";

export const useQueryParams = (): QueryParams => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    if (urlParams.size === 0) return { freezeFields: false };

    const searchParams = (() => {
        const dataParam = urlParams.get("data");
        if (dataParam) {
            try {
                return new URLSearchParams(atob(dataParam));
            } catch (error) {
                console.error("Failed to decode string", error);
            }
        }
        return urlParams;
    })();

    return {
        country: searchParams.get("country"),
        brand: searchParams.get("brand"),
        model: searchParams.get("model"),
        freezeFields: true,
    };
};
